// API 주소 자동 설정
// 우선순위:
//   1. REACT_APP_API_BASE (Phase 2.3 도메인 분리 후 https://api.autodex.kr)
//   2. production: window.location.origin (Phase 2.3 이전 단일 도메인 운영 — 폴백)
//   3. development: http://localhost:4000
var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
var _runtimeBase = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:4000';
var API_ORIGIN = _envBase || _runtimeBase;
var API = API_ORIGIN + '/api';

// 업체 계정이면 companyId 쿼리 파라미터 추가하는 헬퍼
var carsUrl = function(user) {
  if (user && user.role === '업체' && user.companyId > 0) {
    return API + '/cars?companyId=' + user.companyId;
  }
  return API + '/cars';
};

// JWT 토큰 관리
var getToken = function() {
  return localStorage.getItem('autodoc_token') || '';
};

// 세션 만료(401) 중앙 처리 — 한 번만 안내+로그아웃 (동시 다발 401 중복 alert 방지)
var _authExpiredHandled = false;
var handleAuthExpired = function(code) {
  if (_authExpiredHandled) return;
  _authExpiredHandled = true;
  var msg = code === 'SESSION_SUPERSEDED'
    ? '다른 기기/창에서 로그인되어 로그아웃되었습니다. 다시 로그인해주세요.'
    : '세션이 만료되었습니다. 다시 로그인해주세요.';
  try { window.alert(msg); } catch (_e) {}
  try { localStorage.removeItem('autodoc_token'); sessionStorage.removeItem('autodoc_user'); } catch (_e) {}
  var rt = (window.location.pathname && window.location.pathname.charAt(0) === '/') ? window.location.pathname : '/main';
  window.location.href = '/login?returnUrl=' + encodeURIComponent(rt);
};

// 인증 헤더 포함 fetch (점진적 적용용)
var authFetch = function(url, options) {
  options = options || {};
  options.headers = options.headers || {};
  var token = getToken();
  if (token) {
    options.headers['Authorization'] = 'Bearer ' + token;
  }
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json';
  }
  return fetch(url, options).then(function(res) {
    // 토큰이 있는데 401 → 세션 무효(다른 기기 로그인/만료/로그아웃 블랙리스트).
    // SESSION_SUPERSEDED 등 백엔드 신호를 잡아 안내 후 로그인 유도 (이전엔 무시 → CarList 등 빈 화면/크래시).
    if (res.status === 401 && getToken()) {
      res.clone().json().then(function(body) {
        handleAuthExpired(body && body.code);
      }).catch(function() { handleAuthExpired(null); });
      // 세션 무효 응답을 호출자에게 넘기지 않는다 (2026-08-28).
      //   기존: return res → 호출자 체인이 계속 돌아 에러 바디({error:'로그인이 필요합니다'})를
      //   데이터로 간주하고 상태에 그대로 넣었다(setCars(d) 등) → 리렌더에서
      //   "TypeError: cars.find is not a function". 로그인 페이지로 이동하기 직전에
      //   크래시 화면이 먼저 떴다 (/main/invoice 외 다수 화면에서 재현).
      //   reject 가 아니라 미해결 Promise 인 이유: authFetch 호출부 585곳 중 다수가
      //   .catch 를 달지 않아 reject 는 unhandled rejection 을 대량 발생시킨다.
      //   handleAuthExpired 가 반드시 location.href 로 이동시키므로 이 Promise 의
      //   미해결은 페이지 수명과 함께 끝난다.
      return new Promise(function() {});
    }
    return res;
  });
};

export { API, API_ORIGIN, carsUrl, getToken, authFetch };
export default API;
